<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard v-if="form">
        <CCardBody>
          <h3>
            Edit Style
          </h3>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>
          <CInput label="Name" type="text" placeholder="Name" disabled v-model="form.style_name"></CInput>
          <div style="width:100%;float:left;padding-bottom:15px;">
            <label>Active?</label>
            <div>
              <CButton size="sm" @click="form.active = 1, update()" :color="form.active === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.active = 0, update()" style="margin-left:5px;" :color="form.active === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <CInput
            label="Colorway Min Quantity"
            type="text"
            placeholder="Leave blank for no min quantity"
            v-model="form.colorway_min_quantity"
            ></CInput>
          <div style="width:100%;float:left;padding-bottom:15px;">
            <label>Band Option?</label>
            <div>
              <CButton size="sm" @click="form.band_option = 1, update()" :color="form.band_option === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.band_option = 0, update()" style="margin-left:5px;" :color="form.band_option === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <div style="width:100%;float:left;padding-bottom:15px;">
            <label>Rope Option?</label>
            <div>
              <CButton size="sm" @click="form.rope_option = 1, update()" :color="form.rope_option === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.rope_option = 0, update()" style="margin-left:5px;" :color="form.rope_option === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>

          <div style="width:100%;float:left;padding-bottom:15px;">
            <label>Leather Option?</label>
            <div>
              <CButton size="sm" @click="form.leather_option = 1, update()" :color="form.leather_option === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.leather_option = 0, update()" style="margin-left:5px;" :color="form.leather_option === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>

          <div style="width:100%;float:left;" v-if="form.sizes">
            <CCard>
              <CCardHeader color="secondary">Size(s)</CCardHeader>
              <CCardBody>
                <table class="table">
                  <thead>
                    <tr>
                      <th>Size</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="size in form.sizes">
                      <td>{{size.size_name}}</td>
                      <td>
                        <CButton size="sm" @click="save(size, 1, 'style_sizes')" :color="size.active === 1 ? 'success': 'outline-success'">Active</CButton>
                        <CButton size="sm" @click="save(size, 0, 'style_sizes')" style="margin-left:5px;" :color="size.active === 0 ? 'danger': 'outline-danger'">Inactive</CButton>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CCardBody>
            </CCard>
          </div>

          <div style="width:100%;float:left;" v-if="form.colors">
            <CCard>
              <CCardHeader color="secondary">Color(s)</CCardHeader>
              <CCardBody>
                <table class="table">
                  <thead>
                    <tr>
                      <th>Color</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="color in form.colors">
                      <td>{{color.color_name}}</td>
                      <td>
                        <CButton size="sm" @click="save(color, 1, 'style_colors')" :color="color.dropping_style === 1 ? 'danger': 'outline-danger'">Dropping Style</CButton>
                        <CButton size="sm" @click="save(color, 0, 'style_colors')" style="margin-left:5px;" :color="color.dropping_style === 0 ? 'success': 'outline-success'">Keep Style</CButton>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CCardBody>
            </CCard>
          </div>

          <div style="width:100%;float:left;" v-if="bandOptions && form.band_option && form.colors">
            <CCard>
              <CCardHeader color="info">Band Options</CCardHeader>
              <CCardBody>
                <div style="width:100%;float:left;">
                  <CDataTable
                    :items="bandOptions"
                    :fields="bandFields"
                    table-filter
                    :items-per-page="10"
                    pagination
                    :responsive="false"
                  >
                    <template #sku="{item}">
                      <td>
                        <input type="text" class="form-control" v-model="item.band_sku" />
                      </td>
                    </template>
                    <template #name="{item}">
                      <td>
                        <input type="text" class="form-control" v-model="item.band_name" />
                      </td>
                    </template>
                    <template #color_name="{item}">
                      <td>
                        <input type="text" class="form-control" v-model="item.band_color_name" />
                      </td>
                    </template>
                    <template #color_code="{item}">
                      <td>
                        <input type="text" class="form-control" v-model="item.band_color_code" />
                      </td>
                    </template>
                    <template #specific_color="{item}">
                      <td>
                        <!-- <input type="text" class="form-control" v-model="item.rope_color_code" /> -->
                        <v-select :options="form.colors" v-model="item.specific_color" label="color_name"></v-select>
                      </td>
                    </template>
                    <template #actions="{item, index}">
                      <td>
                        <CButton size="sm" color="danger" @click="removeOption('bands', item, index)">
                          <CIcon name="cil-trash" />
                        </CButton>
                      </td>
                    </template>
                  </CDataTable>

                  <div style="width:100%;float:left;text-align:center;margin-top:15px;">
                    <CButton size="sm" color="info" @click="bandOptions.push(getBandOption())">Add Band Option</CButton>
                  </div>

                  <div style="width:100%;float:left;text-align:center;margin-top:15px;">
                    <CButton size="sm" color="success" @click="saveBandRopeOptions('bands')">Save Band Options</CButton>
                  </div>
                </div>
              </CCardBody>
            </CCard>
          </div>

          <div style="width:100%;float:left;" v-if="ropeOptions && form.rope_option">
            <CCard>
              <CCardHeader color="info">Rope Options</CCardHeader>
              <CCardBody>
                <div style="width:100%;float:left;">
                  <CDataTable
                    :items="ropeOptions"
                    :fields="ropeFields"
                    table-filter
                    :items-per-page="10"
                    pagination
                  >
                    <template #sku="{item}">
                      <td>
                        <input type="text" class="form-control" v-model="item.rope_sku" />
                      </td>
                    </template>
                    <template #name="{item}">
                      <td>cust
                        <input type="text" class="form-control" v-model="item.rope_name" />
                      </td>
                    </template>
                    <template #color_name="{item}">
                      <td>
                        <input type="text" class="form-control" v-model="item.rope_color_name" />
                      </td>
                    </template>
                    <template #color_code="{item}">
                      <td>
                        <input type="text" class="form-control" v-model="item.rope_color_code" />
                      </td>
                    </template>
                    <template #actions="{item, index}">
                      <td>
                        <CButton size="sm" color="danger" @click="removeOption('ropes', item, index)">
                          <CIcon name="cil-trash" />
                        </CButton>
                      </td>
                    </template>
                  </CDataTable>

                  <div style="width:100%;float:left;text-align:center;margin-top:15px;">
                    <CButton size="sm" color="success" @click="ropeOptions.push(getRopeOption())">Add Rope Option</CButton>
                  </div>

                  <div style="width:100%;float:left;text-align:center;margin-top:15px;">
                    <CButton size="sm" color="success" @click="saveBandRopeOptions('ropes')">Save Rope Options</CButton>
                  </div>
                </div>
              </CCardBody>
            </CCard>
          </div>

          <div style="width:100%;float:left;" v-if="leatherOptions && form.leather_option">
            <CCard>
              <CCardHeader color="info">Leather Options</CCardHeader>
              <CCardBody>
                <div style="width:100%;float:left;">
                  <CDataTable
                    :items="leatherOptions"
                    :fields="leatherFields"
                    table-filter
                    :items-per-page="10"
                    pagination
                  >
                    <template #leather_name="{item}">
                      <td>
                        <input type="text" class="form-control" v-model="item.leather_name" />
                      </td>
                    </template>
                    <template #leather_color="{item}">
                      <td>
                        <input type="text" class="form-control" v-model="item.leather_color" />
                      </td>
                    </template>

                    <template #internal_id="{item}">
                      <td>
                        <input type="text" class="form-control" v-model="item.internal_id" @change="saveSize(item)" />
                      </td>
                    </template>

                    
                    <template #actions="{item, index}">
                      <td>
                        <CButton size="sm" color="danger" @click="removeOption('leather', item, index)">
                          <CIcon name="cil-trash" />
                        </CButton>
                      </td>
                    </template>
                  </CDataTable>

                  <div style="width:100%;float:left;text-align:center;margin-top:15px;">
                    <CButton size="sm" color="success" @click="leatherOptions.push(getLeatherOption())">Add Leather Option</CButton>
                  </div>

                  <div style="width:100%;float:left;text-align:center;margin-top:15px;">
                    <CButton size="sm" color="success" @click="saveBandRopeOptions('leather')">Save Leather Options</CButton>
                  </div>
                </div>
              </CCardBody>
            </CCard>
          </div>
          <!-- <div style="width:100%;float:left;">
            <CButton size="sm" color="primary" @click="update()">Save</CButton>
            <CButton size="sm" color="bg-gray-100" class="ml-2" @click="goBack">Back</CButton>
          </div> -->
          <div style="width:100;float:left;height:50px;margin-top:15px;">
            <CAlert
              :show.sync="dismissCountDown"
              color="primary"
              fade
            >
              ({{dismissCountDown}}) {{ message }}
            </CAlert>
          </div>
          <spacer />
          <div style="width:100%;float:left;">
            <CCard>
              <CCardHeader color="success">Style Color Sizes</CCardHeader>
              <CCardBody>
                <div style="width:100%;float:left;">
                  <CDataTable
                    :items="form.inventory"
                    :fields="fields"
                    column-filter
                    table-filter
                    :items-per-page="10"
                    pagination
                    v-if="form"
                  >
                    <template #sizes-header>
                      <CButton size="sm" disabled color="success">Active</CButton>
                      <CButton size="sm" class="ml-1" disabled color="outline-danger">Inactive</CButton>
                    </template>
                    <!-- <template #active="{item}">
                      <td>
                        <CButton size="sm" @click="save(item, 1, 'style_colors')" :color="item.active === 1 ? 'success': 'outline-success'">Active</CButton>
                        <CButton size="sm" @click="save(item, 0, 'style_colors')" style="margin-left:5px;" :color="item.active === 0 ? 'danger': 'outline-danger'">Inactive</CButton>
                      </td>
                    </template> -->
                    <template #active="{item}">
                      <td>
                        <!-- <div style="width:150px;float:left;border:1px solid #e0e0e0;text-align:center;border-radius:5px;" v-for="s in item.sizes"> -->
                          <CButton size="sm" @click="item.active === 0 ? item.active = 1 : item.active = 0, saveSize(item)" :color="item.active === 1 ? 'success': 'outline-danger'">{{item.size_name}}</CButton>
                        <!-- </div> -->
                      </td>
                    </template>
                    <template #active_date="{item}">
                      <td>
                        <input type="date" v-model="item.active_date" @change="saveSize(item)" class="form-control" />
                      </td>
                    </template>
                    <template #internal_id="{item}">
                      <td>
                        <input type="text" class="form-control" v-model="item.internal_id" @change="saveSize(item)" />
                      </td>
                    </template>
                  </CDataTable>
                </div>
              </CCardBody>
            </CCard>
          </div>
          <!-- <div style="width:100%;float:left;">
            <label>Decorations</label>
            <multiselect
              v-if="decorations" 
              v-model="form.decorations" 
              :options="decorations" 
              :multiple="true" 
              label="decoration_name" 
              track-by="decoration_id"
            />
          </div>
          <div style="width:100%;float:left;">
            <label>Locations</label>
            <multiselect
              v-if="locations" 
              v-model="form.locations" 
              :options="locations" 
              :multiple="true" 
              label="location_name" 
              track-by="location_id"
            />
          </div>
          <div style="width:100%;float:left;">
            <label>Sizes</label>
            <multiselect
              v-if="sizes" 
              v-model="form.sizes" 
              :options="sizes" 
              :multiple="true" 
              label="size_name" 
              track-by="size_id"
            />
          </div>
          <div style="width:100%;float:left;">
            <label>Colors</label>
            <multiselect
              v-if="colors" 
              v-model="form.colors" 
              :options="colors" 
              :multiple="true" 
              label="color_code" 
              track-by="color_id"
            />
          </div> -->
          <div style="width:100%;float:left;margin-top:15px;" v-if="!loading">
            <CButton color="primary" @click="update()">Save</CButton>
          </div>
          <small-loader v-else-if="loading"></small-loader>
          <div style="width:100;float:left;height:50px;margin-top:15px;">
            <CAlert
              :show.sync="dismissCountDown"
              color="primary"
              fade
            >
              ({{dismissCountDown}}) {{ message }}
            </CAlert>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Multiselect from 'vue-multiselect'
var methods = {}

methods.goBack = function () {
  this.$router.go(-1)
}

methods.getStyle = function () {
  let self = this;
  axios.get(   this.$apiAdress + '/api/styles/edit?token=' + localStorage.getItem("api_token") + '&id=' + self.$route.params.id)
  .then(function (response) {
      // self.name = response.data.menulist.name;
      self.form = response.data.style
      self.colors = response.data.colors
      self.sizes = response.data.sizes
      console.log(response)
  }).catch(function (error) {
      console.log(error);
      // self.$router.push({ path: '/login' });
  });
}

methods.saveBandRopeOptions = function (type) {
  const postData = {
    type: type,
    bandOptions: this.bandOptions,
    ropeOptions: this.ropeOptions,
    leatherOptions: this.leatherOptions,
    style_id: this.$route.params.id
  }
  axios.post(this.$apiAdress + '/api/styles/updateBandRopeOptions?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    window.Swal.fire({
      type: 'success',
      title: 'Saved!'
    })
  }).catch(e => {
    window.Swal.fire({
      type: 'error',
      title: 'This was not saved. Something went wrong.'
    })
  })
}

methods.removeOption = function (type, item, index) {
  const postData = {
    type: type,
    item: item
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/styles/removeBandRopeOptions?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    window.Swal.fire({
      type: 'success',
      title: 'Saved!'
    })

    if (type === 'bands') {
      this.bandOptions.splice(index, 1)
    } else if (type === 'ropes') {
      this.ropeOptions.splice(index, 1)
    } else if (type === 'leather') {
      this.leatherOptions.splice(index, 1)
    }
  })
}

methods.getBandRopeOptions = function () {
  let self = this
  axios.get(   this.$apiAdress + '/api/styles/getBandRopeOptions?token=' + localStorage.getItem("api_token") + '&id=' + self.$route.params.id)
  .then(function (response) {
    console.log('reop options')
      // self.name = response.data.menulist.name;
      self.bandOptions = response.data.bands
      self.ropeOptions = response.data.ropes
      self.leatherOptions = response.data.leather
      if (!self.bandOptions.length) {
        self.bandOptions = [self.getBandOption()]
      }
      if (!self.leatherOptions.length) {
        self.leatherOptions = [self.getLeatherOption()]
      }
      if (!self.ropeOptions.length) {
        self.ropeOptions = [self.getRopeOption()]
      }
      console.log(response)
  }).catch(function (error) {
      console.log(error);
      // self.$router.push({ path: '/login' });
  });
}

methods.getBandOption = function() {
  return {
    style_id: this.$route.params.id,
    band_sku: '',
    band_name: '',
    band_color_name: '',
    band_color_code: ''
  }
}

methods.getLeatherOption = function () {
  return {
    style_id: this.$route.params.id,
    leather_color: '',
    leather_name: ''
  }
}

methods.getRopeOption = function() {
  return {
    style_id: this.$route.params.id,
    rope_sku: '',
    rope_name: '',
    rope_color_name: '',
    rope_color_code: ''
  }
}

methods.save = function (item, val, type) {
  if (type !== 'style_colors') {
    item.active = val
  } else {
    item.dropping_style = val
  }
  const postData = {
    item: item,
    type: type
  }
  axios.post(   this.$apiAdress + '/api/styles/updateStyleColors' + '?token=' + localStorage.getItem("api_token"), postData)
  .then(response => {
      
      // self.showAlert();
  }).catch(error => {
      window.Swal.fire({
        type: 'danger',
        title: 'Oops!',
        text: 'Something went wrong.'
      })
  });
}

methods.saveSize = function (s) {
  console.log('save size')
  console.log(s)
  // if (s.active) {
  //   s.active = 0
  // } else {
  //   s.active = 1
  // }
  const postData = {
    item: s,
    type: 'style_color_sizes_quantities'
  }
  axios.post(   this.$apiAdress + '/api/styles/updateStyleColors' + '?token=' + localStorage.getItem("api_token"), postData)
  .then(response => {
      
      // self.showAlert();
  }).catch(error => {
      window.Swal.fire({
        type: 'danger',
        title: 'Oops!',
        text: 'Something went wrong.'
      })
  });
}

methods.update = function () {
  let self = this;
  console.log(this.form)
  axios.post(   this.$apiAdress + '/api/styles/update' + '?token=' + localStorage.getItem("api_token"), self.form)
  .then(function (response) {
      self.message = 'Successfully updated this style.';
      self.showAlert();
  }).catch(function (error) {
      if(error.response.data.message == 'The given data was invalid.'){
        self.message = '';
        for (let key in error.response.data.errors) {
          if (error.response.data.errors.hasOwnProperty(key)) {
            self.message += error.response.data.errors[key][0] + '  ';
          }
        }
        self.showAlert();
      }
  });
}

methods.showAlert = function () {
  this.dismissCountDown = this.dismissSecs
}

export default {
  name: 'EditStyle',
  data: () => {
    return {
        form: null,
        message: '',
        dismissSecs: 3,
        dismissCountDown: 0,
        loading: false,
        leatherOptions: null,
        colors: null,
        decorations: null,
        sizes: null,
        locations: null,
        bandOptions: null,
        ropeOptions: null,
        fields: ['color_name', 'color_code', 'size_name', 'active', 'active_date', 'internal_id'],
        bandFields: ['sku', 'name', 'color_name', 'color_code', 'specific_color', 'actions'],
        ropeFields: ['sku', 'name', 'color_name', 'color_code', 'actions'],
        leatherFields: ['leather_name', 'leather_color', 'internal_id', 'actions'],
    }
  },
  components: {
    Multiselect
  },
  methods: methods,
  mounted: function(){
    this.getStyle()
    this.getBandRopeOptions()
  }
}


</script>
